import type { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

const DISPLAY_NAME = 'ProductInformation.ProductBadgeContainer';

interface Props {
  className?: string;
  children?: ReactNode;
}

/**
 * 상품 카드 내 라벨(쿠폰 / 최저가도전 등)을 한 줄에 정렬해 묶어주는 컨테이너.
 * 가격 영역과의 간격(`pt-[6px]`)을 자체 처리하므로 호출자는 위치만 선택한다.
 */
export const ProductBadgeContainer: FC<Props> = ({ className, children }) => (
  <div className={twMerge('flex items-center gap-1 pt-[6px]!', className)}>{children}</div>
);

ProductBadgeContainer.displayName = DISPLAY_NAME;
